import React, { useRef } from 'react';
import { useState } from 'react';
// @ts-ignore
import moment from 'moment';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { useAppContext } from '../../../../Services/AppContext';
import HealthPlanOtherConsultations from './HealthPlanOtherConsultations';
import { Size } from '../../../../Enums/Size.enum';

interface HealthPlanOtherConsultationsModalProps {
	opened: boolean;
	onClose: any;
	disableSubmit?: boolean;
}

export default function HealthPlanOtherConsultationsModal(
	props: HealthPlanOtherConsultationsModalProps,
) {
	const { opened, onClose, disableSubmit } = props;
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header title={'component.healthPlan.item.otherConsultation'} />
			<Modal.Content contentScroll={true}>
				<HealthPlanOtherConsultations
					onSuccess={onClose}
					disableSubmit={disableSubmit}
				/>
			</Modal.Content>
		</Modal>
	);
}
